import { Tooltip } from 'platform/components';
import { useFormatNumber } from 'platform/locale';
import { isNotNil } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type IntegerCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};
export function IntegerCellRenderer(props: IntegerCellRendererProps) {
  const className = getCellClassName(props.column);
  const formatNumber = useFormatNumber();
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);
  const value = isNotNil(props.value) ? formatNumber(Number(props.value), 0) : '';
  return <Tooltip {...tooltipProps} label={value}>
      <div className={className}>{value}</div>
    </Tooltip>;
}